<template>
  
  <el-dialog v-if="dialogVisible" :visible.sync="dialogVisible" @close="qx()"  title="查看" :close-on-click-modal="false" :close-on-press-escape="false">

    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '130px' : '130px'">
      <h3 class='h3'>甲方(借款人)</h3>
      <div class="line-box">
      <el-form-item label="姓名"   class="styW">
          <el-input v-model="dataForm.custName" disabled placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item label="手机号"  class="styW">
          <el-input v-model="dataForm.mobile" disabled placeholder="手机号" ></el-input>
      </el-form-item>
      <el-form-item label="身份证号码"  class="styW">
          <el-input v-model="dataForm.idNo" disabled placeholder="证件号码"></el-input>
      </el-form-item>
      <el-form-item label="现住地址"  class="styW">
          <el-input v-model="dataForm.address" disabled placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="邮箱地址"  class="styW" >
          <el-input v-model="dataForm.email" disabled  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item class="styW" label="银行名称">
        <el-input  v-model="dataForm.bankName" disabled placeholder="银行名称"></el-input>
      </el-form-item>
      <el-form-item class="styW" label="银行卡号" >
          <el-input  v-model="dataForm.bankCardNo" disabled placeholder="银行卡号"></el-input>
      </el-form-item>
     
    </div>
      <el-form-item label="添加共借人" prop="productCode">
          <el-button @click="gjr = true">添加共借人</el-button>
      </el-form-item>
      <!-- 共借人添加 -->
      <el-card v-if="gjr">
        <el-form :model="relationList" :rules="rules"
        :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'"
         ref="relationList" >
         <div class="line-box">
          <el-form-item label="姓名" prop="name"  class="styW">
              <el-input v-model="relationList.name"  placeholder="姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile"  class="styW">
                <el-input v-model="relationList.mobile"  placeholder="手机号" ></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="idNo"  class="styW">
                <el-input v-model="relationList.idNo"  placeholder="证件号码"></el-input>
              </el-form-item>
            <el-form-item label="地址/住址" prop="addr"  class="styW">
                <el-input v-model="relationList.addr"  placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="邮箱地址" prop="email"  class="styW">
                <el-input v-model="relationList.email" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
            <el-form-item label="操作" >
              <el-button @click="gjr = false">取消</el-button>
              <el-button @click="submitForm('relationList')" >添加</el-button>
            </el-form-item>
        </el-form>
      </el-card>

      <h3 class='h3' v-if="dataForm.relationList.length > 0">共借人</h3>
      <div class="line-box">

     <div class="line-box">
      <div class="gjr" v-for="(item,index) in dataForm.relationList" :key="item.idNo" >
          <el-form-item class="styW" label="姓名" :prop="'relationList.' + index + '.name'" :rules="{ required: true, pattern: /^[\u4E00-\u9FA5]+$/,message: '用户名只能为中文', trigger: 'blur' }">
            <el-input v-model="item.name"  placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item class="styW" label="Tel" :prop="'relationList.' + index + '.mobile'" :rules="{required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/, message: '请输入正确的电话号码', trigger: 'blur'}">
              <el-input v-model="item.mobile"  placeholder="手机号"></el-input>
          </el-form-item>
          <el-form-item class="styW" label="身份证号码" :prop="'relationList.' + index + '.idNo'" :rules="{ required: true,  pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号', trigger: 'blur' }">
              <el-input  v-model="item.idNo"  placeholder="证件号码"></el-input>
            </el-form-item>
          <el-form-item class="styW" label="地址/住址" :prop="'relationList.' + index + '.addr'" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
              <el-input v-model="item.addr"  placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item  class="styW" label="邮箱地址" :prop="'relationList.' + index + '.email'" :rules="{ required: true,type:'email', message: '请输入正确的邮箱', trigger: 'blur' }">
              <el-input v-model="item.email"  placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="styW" label="是否删除共借人" >
            <el-button @click="del(item.mobile)">删除</el-button>
          </el-form-item>
      </div>
    </div>
    </div>

    <h3 class="h3">借款信息</h3>
    <div class="line-box">
      <el-form-item class="styW" label="借款产品" prop="loanApplyList[0].productCode" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select v-model="dataForm.loanApplyList[0].productCode" clearable placeholder="请选择" >
          <el-option
            v-for="item in borrowType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="isShowPledge" class="styW" label="贷款种类" prop="loanTypes" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select v-model="dataForm.loanTypes" clearable placeholder="请选择" >
          <el-option
            v-for="item in loanTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="isShowPledge" class="styW" label="贷款详细用途" prop="loanDetailed" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select v-model="dataForm.loanDetailed" clearable placeholder="请选择" >
          <el-option
            v-for="item in loanDetailed"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="isShowPledge" class="styW" label="还款方式" prop="repaymentTypeCode" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select v-model="dataForm.repaymentTypeCode" clearable placeholder="请选择" >
          <el-option
            v-for="item in repaymentTypeCode"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item v-if="!isShowPledge" class="styW" label="借款用途" prop="loanApplyList[0].loanUsage" :rules="{ required: true, pattern: /^[\u4E00-\u9FA5]+$/,message: '只能为中文' }">
          <el-input v-model="dataForm.loanApplyList[0].loanUsage" placeholder="请输入"></el-input>
      </el-form-item>
      
      

        <el-form-item class="styW" label="借款利率" prop="loanApplyList[0].loanRate" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
          <el-input-number v-model="dataForm.loanApplyList[0].loanRate" :precision="2" :min="0.1" :step="0.1" :max="100"></el-input-number>
      </el-form-item>
      <el-form-item class="styW" label="结息方式" prop="loanApplyList[0].interestTypeCode" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
          
        <el-select v-model="dataForm.loanApplyList[0].interestTypeCode" placeholder="请输入">
          <el-option
            v-for="(item,index) in interestTypeCode"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  class="styW" label="借款金额-元" prop="loanApplyList[0].loanAmount" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
          <el-input-number  v-model="dataForm.loanApplyList[0].loanAmount" :min="0"  ></el-input-number>
      </el-form-item>
      <el-form-item class="styW" label="逾期利率" prop="loanApplyList[0].overdueRate" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }" >
        <el-input-number v-model="dataForm.loanApplyList[0].overdueRate" :precision="2" :min="0" :step="0.1" :max="200"></el-input-number>
       </el-form-item>
       
      <el-form-item  label="借款期限" prop="loanApplyList[0].initPeriod" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
          
      </el-form-item>
      </div>
      <el-form-item class="styW" label="合同数量" prop="registerProvinceCode">
        <div  class="ht">
          <div>合同共 {{dataForm.relationList.length + 2}} 份</div>
          <div>甲方 {{dataForm.relationList.length + 1}} 份 乙方 1 份</div>
        </div>
      </el-form-item>

      <el-form-item class="styW" label="合同签订日期" prop="loanApplyList[0].createTime" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
        <el-date-picker
            v-model="dataForm.loanApplyList[0].createTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            >
          </el-date-picker>
      </el-form-item>
    </div>
    <h3 class="h3" v-if="isShowPledge">抵押信息</h3>
    <div class="line-box" v-if="isShowPledge">
      <div style="width:100%; display: flex;"> 
        <el-form-item  label="签署地" prop="sheng" >
          <el-input type="text"></el-input>
        </el-form-item>
     </div>

      <el-form-item class="styW" label="抵押物坐落" prop="mortgageAddress" :rules="{ required: true,message: '不能为空' }">
          <el-input v-model="dataForm.mortgageAddress" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="建筑面积(平方米)" prop="buildArea"  class="styW" :rules="{ required: true,message: '不能为空' }">
        <el-input-number v-model="dataForm.buildArea" :min="0"  ></el-input-number>
      </el-form-item>

      <el-form-item label="" prop="useArea"  class="styW" :rules="{ required: true,message: '不能为空' }">
        
        <span slot="label" > 
          <el-tooltip class="item" effect="dark" content="土地使用权面积(平方米)" placement="top">
              <span class="mylabel">
                土地使用权面积
              </span>
          </el-tooltip>
        </span>
     
        <el-input-number v-model="dataForm.useArea" :min="0"  ></el-input-number>
      </el-form-item>

      <el-form-item label=""  prop="mortgageNo"  :rules="{ required: true,message: '不能为空' }">
        <template slot="label" >
          <span slot="label" > 
          <el-tooltip class="item" effect="dark" content="房屋所有权证/房地产权证编号/不动产权证编号" placement="top">
              <span class="mylabel">
                房屋所有权证
              </span>
          </el-tooltip>
        </span>
        </template>
        <el-input v-model="dataForm.mortgageNo" placeholder="请输入" ></el-input>
      </el-form-item>
      <el-form-item label="抵押物价值(万元)" prop="price"  class="styW" :rules="{ required: true,message: '不能为空' }">
        <el-input-number v-model="dataForm.price" :min="0"  ></el-input-number>
      </el-form-item>
      <el-form-item label="抵押物其他详情" prop="mortgageAtt"  class="styW" :rules="{ required: true,message: '不能为空' }">
        <el-input v-model="dataForm.mortgageAtt"   placeholder="请输入" ></el-input>
      </el-form-item>
    </div>
    </el-form>
    <template slot="footer">
      <el-button @click="qx()">关闭</el-button>
      <!-- <el-button type="primary" @click="dataFormSubmitHandle()" :disabled="isButton">{{ $t('confirm') }}</el-button> -->
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  created(){
   
  },
  data () {
    return {
      mobile:'',
      isButton:false,
      interestTypeCode:[],
      loanTypes:[],
      loanDetailed:[],
      repaymentTypeCode:[],
      city:[],
     
    
      infoid:'',
      visible: false,
      dialogVisible:false,
      date:'',
      gjr:false,
      borrowType:[
      ],
      // 共借人
      relationList:{
        "addr": "",
        "email": "",
        "idNo": "",
        "mobile": "",
        "name": "",
      },
       
       
      dataForm: {
        "address": "",
        "areaCode": "",
        "cityCode": "",
        "custName": "",
        email:'',
        "id": '',
        "idNo": "",
        bankName:'',
        bankCardNo:'',
        loanTypes:'',
        loanDetailed:'',
        repaymentTypeCode:'',
        mortgageAddress:'',
        buildArea:'',
        useArea:'',
        mortgageNo:'',
        price:'',
        signAddress:'',
        mortgageAtt:'',
        sheng:'',
        shi:'',
        "loanApplyList": [
          {
            "agreementCode": "",
            "agreementConfirmTime": "",
            "applyStatus": "",
            "capitalPlatformCode": "",
            "contractRate": '',
            "contractSignTime": "",
            "createBy": "",
            "createTime": "",
            "custId": '',
            "custName": "",
            "id": '',
            "idNo": "",
            "initPeriod": '',
            "interestTypeCode": "",
            "isOpen": "",
            "loanAmount": '',
            "loanAmountFee": '',
            "loanApplyTime": "",
            "loanCardNo": "",
            "loanCode": "",
            "loanEndTime": "",
            "loanName": "",
            "loanPeriod": '',
            "loanRate": '',
            "loanStartTime": "",
            "loanUsage": "",
            "mobile": "",
            "overdueRate": '',
            "periodUnitCode": "",
            "productCode": "",
            "remark": "",
            "updateBy": "",
            "updateTime": "",
            "version": ''
          }
        ],
    
        "mobile": "",
        "provinceCode": "",
        "registerAddress": "",
        "registerAreaCode": "",
        "registerCityCode": "",
        "registerProvinceCode": "",
        "relationList": [
        ]
	    },
      rules: {
          name: [
          {required: true,message: '请输入用户名',trigger: 'blur'},{min: 2,max: 8,message: '长度在 2 到 8 个字符'},{pattern: /^[\u4E00-\u9FA5]+$/,message: '用户名只能为中文'}
           
          ],
          mobile: [
            { required: true, message: '请输入电话号码', trigger: 'blur' },
            { required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/, message: '请输入正确的电话号码', trigger: 'blur' }
          ],
          idNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 15, max: 18, message: '请如实填写身份证号', trigger: 'blur' },
                {
                    required: true,
                    pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                    message: '请输入正确的身份证号码',
                    trigger: 'blur'
                }
           
          ],
        
          addr: [
            {required: true,message: '请输入地址',trigger: 'blur'}
          ],
          email: [
            { required: true,type:'email', message: '请输入正确的邮箱', trigger: 'blur' }
          ],
         
        },
      
    }
  },
  computed: {
    
    dataRule () {
      return {
        sheng: [ { required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        shi: [ { required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        custCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        custName: [
          {required: true,message: '请输入用户名',trigger: 'blur'},{min: 2,max: 8,message: '长度在 2 到 8 个字符'},{pattern: /^[\u4E00-\u9FA5]+$/,message: '用户名只能为中文'}
        ],
        mobile: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/, message: '请输入正确的手机号码', trigger: 'blur' }
          ],
        bankCardNo: [
        { required: true, message: '请输入银行卡号',min: 12, max: 20, trigger: 'blur', },
        ],
        idNo: [
        { required: true, message: '请输入身份证号', trigger: 'blur' },
        { min: 15, max: 18, message: '请如实填写身份证号', trigger: 'blur' },
              {
                   required: true,
                   pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                   message: '请输入正确的身份证号码',
                   trigger: 'blur'
              }
        ],
      
      
       
      
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
      
        bankName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        
        email: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
       
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    },
    cityList () {
    
      let arr = []
      
      this.dataForm.shi = ''
      this.city.forEach(item =>{
        if(item.name == this.dataForm.sheng){
          console.log(item)
         arr = item.area
        }
      })
      return arr
    },
    isShowPledge () {
      return this.dataForm.loanApplyList[0].productCode == '2' ? true : false
    }
  },
  methods: {
   
    qx(){
      this.$emit('dataFormFS')
      this.dataForm = {
                  "address": "",
                  "areaCode": "",
                  "cityCode": "",
                  "custName": "",
                  "id": '',
                  "idNo": "",
                  "loanApplyList": [
                {
                  "agreementCode": "",
                  "agreementConfirmTime": "",
                  "applyStatus": "",
                 
                  bankName:'',
                  "capitalPlatformCode": "",
                  "contractRate": '',
                  "contractSignTime": "",
                  "createBy": "",
                  "createTime": "",
                  "custId": '',
                  "custName": "",
                  "id": '',
                  "idNo": "",
                  "initPeriod": '',
                  "interestTypeCode": "",
                  "isOpen": "",
                  "loanAmount": '',
                  "loanAmountFee": '',
                  "loanApplyTime": "",
                  "loanCardNo": "",
                  "loanCode": "",
                  "loanEndTime": "",
                  "loanName": "",
                  "loanPeriod": '',
                  "loanRate": '',
                  "loanStartTime": "",
                  "loanUsage": "",
                  "mobile": "",
                  "overdueRate": '',
                  "periodUnitCode": "",
                  "productCode": "",
                  "remark": "",
                 
                  "updateBy": "",
                  "updateTime": "",
                  "version": ''
                }
              ],
          
              "mobile": "",
              "provinceCode": "",
              "registerAddress": "",
              "registerAreaCode": "",
              "registerCityCode": "",
              "registerProvinceCode": "",
              "relationList": [
              ]
	                  }
      this.dialogVisible = false
    },
    getFormData(){
      this.dialogVisible = true
      this.$http.get(`/loan/tloanapply/${this.infoid}`).then( r => {
        console.log(r)
        this.dataForm.loanApplyList[0].initPeriod = String(this.dataForm.loanApplyList[0].initPeriod)
        
        let loanApplyList = JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0]))
        this.dataForm.loanApplyList = loanApplyList
        let custName = r.data.data.custName
        let mobile = r.data.data.mobile
        let idNo = r.data.data.idNo
        let bankName = r.data.data.bankName
        let bankCardNo = r.data.data.bankCardNo
        this.dataForm.email = r.data.data.email
        let address = r.data.data.address
        this.dataForm = {
         ...this.dataForm,
         mobile,
         idNo,
         custName,
         address,
         id:'',
         bankCardNo:bankCardNo,
         bankName:bankName,
         loanApplyList:[{
          ...this.dataForm.loanApplyList,
          custId:this.infoid,
         }]

        } 
       
      })
    
    },
    // 删除共借人
    del(mobile){
      this.dataForm.relationList = this.dataForm.relationList.filter(item => item.mobile != mobile)
    },
     // 添加共借人
    submitForm(relationList) {
        this.$refs[relationList].validate((valid) => {
          if (valid) {
            
                this.gjr = false
                // 添加成功刷新数据
                console.log(this.relationList)
                 this.dataForm.relationList.push(JSON.parse(JSON.stringify(this.relationList)))
                 this.relationList = {
                      "addr": "",
                      "email": "",
                      "idNo": "",
                      "mobile": "",
                      "name": "",
                    }
                  console.log(this.dataForm.relationList)
                 this.$message({
                  message: '添加成功',
                  type: 'success'
                })
           
          } else {
          
            return false;
          }
        });
        
      },
     
   
    getTimes(){
      // if (this.date != null) {
      //     this.dataForm.startDate = this.date[0]
      //     this.dataForm.endDate = this.date[1]
      //   }else{
      //     this.dataForm.startDate =''
      //     this.dataForm.endDate = ''
      //   }
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    handleClose(tag) {
        this.tags.splice(this.tags.indexOf(tag), 1);
      },
    // 获取信息
    getInfo () {
      this.$http.get(`/loan/tcustbase?id=${this.dataForm.id}`).then(({ data: res }) => {
        // if (res.code !== 0) {
        //   return this.$message.error(res.msg)
        // }
        // this.dataForm = {
        //   ...this.dataForm,
        //   ...res.data
        // }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      
      this.mobile = this.dataForm.mobile
      console.log(this.mobile)
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          
          console.log(1)
          this.isButton = true
       
          let dataForm = {
                  "custId": JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].custId)) ,
                  "productCode":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].productCode))  ,
                  "loanUsage":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].loanUsage))  ,
                  "loanRate":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].loanRate))  ,
                  "interestTypeCode":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].interestTypeCode))  ,
                  "loanAmount":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].loanAmount))  ,
                  "overdueRate":JSON.parse(JSON.stringify( this.dataForm.loanApplyList[0].overdueRate)) ,
                  "loanStartTime":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].initPeriod[0]))  ,
                  "loanEndTime":JSON.parse(JSON.stringify( this.dataForm.loanApplyList[0].initPeriod[1])),
                  "contractSignTime":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].createTime)),
                  "bankCardNo":this.dataForm.bankCardNo,
                  "bankName":this.dataForm.bankName,
                  "relationList":JSON.parse(JSON.stringify(this.dataForm.relationList)),

                 
                  loanDetailed:this.dataForm.loanDetailed,
                  repaymentTypeCode:this.dataForm.repaymentTypeCode,
                  loanTypes: this.dataForm.loanTypes,
                 
                  mortgageAddress:this.dataForm.mortgageAddress,
                  buildArea:this.dataForm.buildArea,
                  useArea:this.dataForm.useArea,
                  mortgageNo:this.dataForm.mortgageNo,
                  price:this.dataForm.price,
                  signAddress:this.dataForm.sheng + '|' + this.dataForm.shi,
                  mortgageAtt:this.dataForm.mortgageAtt
              }
              
          this.$http.post('/loan/tloanapply',dataForm).then(r => {
             
            if(r.data.code == 0){
            
                this.dataForm = {
                  "address": "",
                  "areaCode": "",
                  "cityCode": "",
                  "custName": "",
                  "id": '',
                  "idNo": "",
                  "loanApplyList": [
                {
                  "agreementCode": "",
                  "agreementConfirmTime": "",
                  "applyStatus": "",
                  "bankCardNo": "",
                  bankName:'',
                  "capitalPlatformCode": "",
                  "contractRate": '',
                  "contractSignTime": "",
                  "createBy": "",
                  "createTime": "",
                  "custId": '',
                  "custName": "",
                  "id": '',
                  "idNo": "",
                  "initPeriod": '',
                  "interestTypeCode": "",
                  "isOpen": "",
                  "loanAmount": '',
                  "loanAmountFee": '',
                  "loanApplyTime": "",
                  "loanCardNo": "",
                  "loanCode": "",
                  "loanEndTime": "",
                  "loanName": "",
                  "loanPeriod": '',
                  "loanRate": '',
                  "loanStartTime": "",
                  "loanUsage": "",
                  "mobile": "",
                  "overdueRate": '',
                  "periodUnitCode": "",
                  "productCode": "",
                  "remark": "",
                 
                  "updateBy": "",
                  "updateTime": "",
                  "version": ''
                }
              ],
          
              "mobile": "",
              "provinceCode": "",
              "registerAddress": "",
              "registerAreaCode": "",
              "registerCityCode": "",
              "registerProvinceCode": "",
              "relationList": [
              ]
	                  }
                this.$message({
                  message: '添加成功',
                  type: 'success',
                })
               
                this.dialogVisible = false
                this.isButton = false
                this.$router.push({
                  path:"/loan-tloanapply",
                  query:{
                    data:this.mobile
                  }
                })
               
            }else{
              this.isButton = false
              this.$message({
                message:r.data.msg,
                type:'warning'
              })
            }
            
          })
          console.log('成功')
        }else{
          console.log('失败')
        }
        // this.$http[!this.dataForm.id ? 'post' : 'put']('/loan/tcustbase/', this.dataForm).then(({ data: res }) => {
        //   if (res.code !== 0) {
        //     return this.$message.error(res.msg)
        //   }
        //   this.$message({
        //     message: this.$t('prompt.success'),
        //     type: 'success',
        //     duration: 500,
        //     onClose: () => {
        //       this.visible = false
        //       this.$emit('refreshDataList')
        //     }
        //   })
        // }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })},
    
    
  
}


</script>

<style lang="scss" scoped>
  @import '../../../assets/css/passWord.css';
 .tj{
  border: 1px solid #ccc;
 }
//  .gjr{
//   border: 1px solid red;
//  }
 .ht{
  display: flex;
  justify-content: space-between;
 }
 .h3{
  margin: 20px 0;
 }
 .styW{
  width: 400px;
 }
 .mylabel{
  width: 120px;

  overflow:hidden;
  text-overflow:ellipsis; 
  white-space:nowrap 
 }
</style>
